export default "__VITE_ASSET__DJCWxR8j__"